export class Menu {
  constructor(public name: string, public url: string, public subs: Menu[] = []) {}
}



// WEBPACK FOOTER //
// ./src/app/models/menu.model.ts